import dayJSLocales from "dayjs/locale.json";
const supportedDayJSLocales = new Set(dayJSLocales.map((locale) => locale.key));
const defaultLocale = "en"; // dayjs default locale is en, if this were to change we would need to update this value

export const getDayJSLocale = () => {
  let locale: Intl.Locale;
  // These should now be valid BCP 47 language tags
  try {
    locale = new Intl.Locale(document.documentElement.lang || "en");
  } catch (e) {
    console.warn(
      `Invalid locale ${document.documentElement.lang} set on html element. Falling back to 'en' for DayJS. Error:`,
      e,
    );
    return defaultLocale;
  }
  const { language, region, script } = locale;

  // do we need any specific overrides? For example, fr-US > fr-ca
  // perhaps we should implement our own fr-us locale?
  // my guess is we would not want fr formatted dates for fr-US users

  if (region) {
    const languageScriptRegion = `${language.toLowerCase()}-${region.toLowerCase()}`;
    if (supportedDayJSLocales.has(languageScriptRegion)) {
      return languageScriptRegion;
    }
  }

  if (script) {
    const languageScript = `${language.toLowerCase()}-${script.toLowerCase()}`;
    if (supportedDayJSLocales.has(languageScript)) {
      return languageScript;
    }
  }

  // fallback to US region
  if (supportedDayJSLocales.has(`${language.toLowerCase()}-us`)) {
    return `${language.toLowerCase()}-us`;
  }

  // fallback to just the language
  if (supportedDayJSLocales.has(language.toLowerCase())) {
    return language.toLowerCase();
  }

  return defaultLocale;
};

export async function loadDayJSLocale() {
  const locale = getDayJSLocale();

  // default locale is already included in main bundle
  if (locale !== defaultLocale) {
    try {
      await import(
        /* webpackChunkName: "dayjs-locale-[request]" */
        `dayjs/locale/${locale}.js`
      );
    } catch (e: unknown) {
      console.warn(
        `Error loading DayJS locale ${locale}, falling back to default locale ${defaultLocale}. Error:`,
        e,
      );
      return defaultLocale;
    }
  }

  return locale;
}
